// TradingViewWidget.jsx
import { observer } from 'mobx-react-lite';
import TvWidgetContainer from './TvWidgetContainer';

const TvSymbolOverview = observer(({ ticker }: { ticker: string }) => {
    return (
        <div className="h-100 w-full">
            <TvWidgetContainer
                scriptSrc="embed-widget-symbol-overview"
                configJson={{
                    lineWidth: 2,
                    lineType: 0,
                    chartType: 'area',
                    chartOnly: false,
                    scalePosition: 'right',
                    scaleMode: 'Normal',
                    valuesTracking: '1',
                    changeMode: 'percent-only',
                    symbols: [[ticker, `${ticker}|1D`]],
                    dateRanges: ['1d|5', '5d|30', '3m|1D', '12m|1D', '60m|1W', 'all|1M'],
                    headerFontSize: 'medium',
                    autosize: true,
                    noTimeScale: false,
                    hideDateRanges: false,
                    hideMarketStatus: false,
                    hideSymbolLogo: false,
                }}
            />
        </div>
    );
});

export default TvSymbolOverview;
